import React from 'react';
import {Avatar, Box, Grid, Sheet, Stack} from '@mui/joy';
import {CallOutlined, MailOutline} from "@mui/icons-material";
import Typography from "@mui/joy/Typography";
import {SummaryModel} from "../model/summary";

function ContactInfo({summary}:{summary:SummaryModel}) {

    return (
        <Box minWidth={{lg:580}} maxWidth={{xs: 'xs', sm: 'sm', md: 900}}>
            <Sheet variant='soft' sx={{paddingX: 1, paddingY: 1, borderRadius: 8,}}>
                <Grid spacing={2} container>
                    <Grid xs={12} lg={7}>
                        <Stack direction='row' spacing={1} alignItems='center'>
                            <Avatar size='sm' variant='solid' color='primary'>
                                <MailOutline/>
                            </Avatar>
                            <Stack direction='column' justifyContent='center'>
                                <Typography level='body-sm'>Email us</Typography>
                                <a
                                    href = {`mailto:${summary?.email}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{textDecoration: "none", padding: 0}}>
                                    <Typography level='body-md'>{summary?.email}</Typography>
                                </a>
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid xs={12} lg={5}>
                        <Stack direction='row' spacing={1} alignItems='center'>
                            <Avatar size='sm' variant='solid' color='primary'>
                                <CallOutlined/>
                            </Avatar>
                            <Stack direction='column' justifyContent='center'>
                                <Typography level='body-sm'>Make a call</Typography>
                                <a
                                    href={`tel:${summary?.phone}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{textDecoration: "none", padding: 0}}>
                                    <Typography level='body-md'>{summary?.phone}</Typography>

                                </a>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Sheet>
        </Box>
    );
}

export default ContactInfo;
